import React from 'react';
import { Button, useTheme } from '@rneui/themed';
import { useTranslation } from 'react-i18next';

const LogoutButton = ({ logout }) => {
  const { theme } = useTheme();
  const { t } = useTranslation();

  return (
    <Button
      type="outline"
      style={{ marginTop: 10 }}
      //buttonStyle={{ backgroundColor: theme.colors.secondary }}
      title={t('personal.logout')}
      onPress={logout}
    />
  );
};

export default LogoutButton;
